import React, { useEffect, useState } from 'react';

import clock from '../../common/svg/launchpad/clock.svg';

export interface Props {
  startDate: Date;
}

export const LaunchpadCountDown: React.FC<Props> = props => {
  const [days, setDays] = useState<number>(0);
  const [hours, setHours] = useState<number>(0);
  const [mins, setMins] = useState<number>(0);
  const [secs, setSecs] = useState<number>(0);

  useEffect(() => {
    const myfunc = setInterval(function () {
      const timeleft = props.startDate.getTime() - new Date().getTime();

      if (timeleft > 0) {
        const cDays = Math.floor(timeleft / (1000 * 60 * 60 * 24));
        const cHours = Math.floor(
          (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        const cMinutes = Math.floor(
          (timeleft % (1000 * 60 * 60)) / (1000 * 60),
        );
        const cSeconds = Math.floor((timeleft % (1000 * 60)) / 1000);

        setDays(cDays);
        setHours(cHours);
        setMins(cMinutes);
        setSecs(cSeconds);
      }

      if (timeleft <= 0) {
        clearInterval(myfunc);
      }
    }, 1000);
  }, [props]);

  return (
    <div className="flex justify-center">
      {props.startDate.getTime() - new Date().getTime() > 0 ? (
        <div className={'flex items-center text-xs xl:text-sm'}>
          <img src={clock} width="12px" height="12px" alt="clock" />
          <div className={'font-semibold text-base sm ml-2'}>{days}</div>
          <div className={'font-light text-thin sm ml-1'}>Days</div>
          <div className={'font-semibold text-base sm ml-1'}>{hours}</div>
          <div className={'font-light text-thin sm ml-1'}>Hours</div>
          <div className={'font-semibold text-base sm ml-1'}>{mins}</div>
          <div className={'font-light text-thin sm ml-1'}>Minutes</div>
          <div className={'font-semibold text-base sm ml-1'}>{secs}</div>
          <div className={'font-light text-thin sm ml-1'}>Seconds</div>
        </div>
      ) : null}
    </div>
  );
};
